import React from 'react';
import './WhatGPT5.css';
import { Feature } from '../../components';

const WhatGPT5 = () => {
  return (
    <section id='about'>
      <div className='about-container'>
        <div className='about-description'>
          <Feature title='What is GPT-3' text='We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.' />
        </div>
        <div className='about-heading-container'>
          <h1 className='gradient_text'>The Possibilities are beyond <div>your imagination</div></h1>
          <p>Explore the Library</p>
        </div>
        <div className='about-features-container'>
          <Feature title="Chatbots" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought." />
          <Feature title="Knowledgebase" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
          <Feature title="Education" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
        </div>
      </div>
    </section>
  )
}

export default WhatGPT5
